/**
 * Before/After Slider - Adjusts the CSS custom property `--position`
 * on the slider container based on range input value.
 */

class BeforeAfterSlider {
    private slider: HTMLInputElement;
    private container: HTMLElement;

    constructor(slider: HTMLInputElement) {
        this.slider = slider;
        this.container = slider.closest('.ba-slider__container') as HTMLElement;

        this.slider.addEventListener('input', this.onInput.bind(this));
    }

    private onInput(): void {
        this.container.style.setProperty('--position', `${this.slider.value}%`);
    }
}

export function setupBeforeAfterSlider(): void {
    const sliders = document.querySelectorAll<HTMLInputElement>('.ba-selector');

    sliders.forEach((slider) => {
        const container = slider.closest('.ba-slider__container');
        if (container) {
            new BeforeAfterSlider(slider);
        }
    });
}

setupBeforeAfterSlider();
